export default __webpack_public_path__ + "static/media/Islamic_lifestyle_website_icon_01.630b35cf.svg";